import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import LiveSection from "./components/LiveSection";
import ColumnsSection from "./components/ColumnsSection";
import DigestSection from "./components/DigestSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <LiveSection />
        <ColumnsSection />
        <DigestSection />
        <AboutSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}